<template>
  <div id="contenedor-agregar-nuevo-responsable-contrato">
    <v-form
      v-model="formularioValido"
      ref="agregarNuevoresponsableContrato"
    >
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Nuevo Responsable
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-autocomplete
              cols="12"
              v-model="responsableContrato.idFuncionario"
              label="Seleccionar Funcionario"
              :items="funcionarios"
              item-text="nombre"
              item-value="id"
              clearable
              :rules="[mixReglas.requerido]"
            >
            </custom-autocomplete>
          </v-row>
          <v-row>
            <v-switch
              cols="12"
              v-model="responsableContrato.principal"
              label="Es Residente de Obra?"
              inset
            >
            </v-switch>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixAgregarContratoResponsable"
            :disabled="!formularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixResponsableContrato from './mixResponsableContrato';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarNuevoResponsableContrato',
  mixins: [mixResponsableContrato],
  props: {
    idContrato: String,
  },
  components: {
    CustomAutocomplete,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      responsableContrato: {
        idContrato: this.idContrato,
        idFuncionario: null,
        principal: false,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarNuevoresponsableContrato.reset();
      this.responsableContrato.principal = false;
    },
  },
};
</script>

<style>
</style>
